<template>
    <div class="flex-col footer-h5">
        <div class="text-wrapper_2 flex-col">
            <a class="text_4" :href="'tel:' + platInfo.tel">客服热线：{{ platInfo.tel }}</a>
        </div>
        <div class="text-group_5 flex-col">
            <div>
                <span class="text_5">
                    <span @click="toHref('legaNotice')">法律声明</span>&nbsp;&nbsp;｜&nbsp;&nbsp;<span @click="toHref('privacyPolicy')">隐私政策</span>
                </span>
            </div>
            <span class="paragraph_1">©&nbsp;2025&nbsp;潍坊农业开放发展集团有限公司&nbsp;
                <br /><span @click="toHref('https://beian.miit.gov.cn','_blank')">鲁ICP备2024099623号</span>
                <!-- <br /><span>运营公司：潍坊农综区智能科技有限公司</span>
                <br /><span>技术支持：北京新盟风控科技有限公司</span> -->
            </span>
        </div>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref } from "vue";
import { useRouter } from 'vue-router'
const { proxy } = getCurrentInstance();
const router = useRouter();
const props = defineProps({
    themeColor: {
        type: String,
        default: 'blue'
    },
    platInfo: {
        type: Object,
        default: {}
    }
})
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};
const toHref = (url, type) => {
    if (!url) {
        return;
    }
    if (type === '_blank' || type == '1') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url);
    }
};
</script>
<style lang="less" scoped>
/* Flex布局基础样式 */
.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.footer-h5 {
    background-color: #F4F4F4;
    padding: 31px 21px 28px 20px;
}

.text-wrapper_2 {
    border-radius: 23px;
    border: 1px solid rgba(26, 26, 26, 1);
    padding: 12px 79px 12px 83px;
}

.text_4 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    line-height: 20px;
}

.text-group_5 {
    margin: 26px 0;
    text-align: center;
}

.text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin: 0 9px 0 11px;
}

.paragraph_1 {
    width: 100%;
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    line-height: 20px;
    margin-top: 11px;
}


.image-wrapper_4 {
    box-shadow: 0px 1px 0px 0px rgba(220, 222, 221, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: flex-center;
    padding: 10px 14px 9px 14px;
}

.image_9 {
    width: 201px;
    height: 25px;
}

.thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 4px 0 5px 102px;
}

.thumbnail_6 {
    width: 16px;
    height: 12px;
    margin: 6px 0 7px 12px;
}

.image_10 {
    position: absolute;
    left: 353px;
    top: 280px;
    width: 12px;
    height: 76px;
}
</style>